import React from "react";
import "./Policy.css";

export default function Disclaimer() {
  return (
    <div className="policy-page">
      <h1>Disclaimer</h1>
      <p>Last updated: August 2025</p>

      <p>
        TravXplo provides travel planning assistance using AI-powered tools and
        third-party APIs. While we aim to offer accurate and useful
        recommendations, we cannot guarantee that all information (such as
        prices, availability, or weather) will always be fully accurate or
        up-to-date.
      </p>

      <h2>Important Notes</h2>
      <p>
        - Our itineraries are for planning purposes and should be cross-checked
        with official travel providers before making bookings. <br />
        - Weather, prices, and travel conditions may change unexpectedly. <br />
        - TravXplo does not accept responsibility for personal losses, travel
        delays, or decisions made based on our recommendations.
      </p>

      <h2>Use of Information</h2>
      <p>
        By using our services, you acknowledge that TravXplo is not liable for
        any outcomes of your travel arrangements. You agree to use our platform
        responsibly and verify information independently.
      </p>
    </div>
  );
}
